import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HttpClient, HttpEvent, HttpEventType } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";

export interface ThumbnailDialogData {
  generatedThumbnailUrl: string;
  videoUrl: string;
  source: "cover" | "step";
}

@Component({
  selector: "app-thumbnail-selection-dialog",
  templateUrl: "./thumbnail-selection-dialog.component.html",
  styleUrls: ["./thumbnail-selection-dialog.component.scss"],
})
export class ThumbnailSelectionDialogComponent implements OnInit {
  generatedThumbnailUrl: string;
  videoUrl: string;
  source: "cover" | "step";
  customThumbnailFile: File = null;
  customThumbnailUrl: string = "";
  selectedThumbnailType: "generated" | "custom" = "generated";
  isUploading: boolean = false;
  uploadProgress: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ThumbnailSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ThumbnailDialogData,
    private http: HttpClient,
    private toastr: ToastrService
  ) {
    this.generatedThumbnailUrl = data.generatedThumbnailUrl;
    this.videoUrl = data.videoUrl;
    this.source = data.source;
  }

  ngOnInit(): void {}

  onThumbnailTypeChange(type: "generated" | "custom") {
    this.selectedThumbnailType = type;
  }

  onCustomThumbnailSelect(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.customThumbnailFile = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.customThumbnailUrl = e.target.result;
      };
      reader.readAsDataURL(this.customThumbnailFile);
    }
  }

  uploadCustomThumbnail() {
    if (!this.customThumbnailFile) {
      this.toastr.warning("Please select a thumbnail image");
      return;
    }

    this.isUploading = true;
    this.uploadProgress = 0;
    const formData = new FormData();
    formData.append("fileData", this.customThumbnailFile);

    this.http
      .post(environment.apiBaseUrl + environment.uploadImageUrl, formData, {
        reportProgress: true,
        observe: "events",
      })
      .subscribe(
        (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (event.total) {
                this.uploadProgress = Math.round(
                  (event.loaded / event.total) * 100
                );
              }
              break;
            case HttpEventType.Response:
              const response = event.body;
              if (response && response.fileName) {
                this.customThumbnailUrl =
                  environment.imageStorageBaseUrl + response.fileName;
                this.isUploading = false;
                this.toastr.success("Thumbnail uploaded successfully");
              }
              break;
          }
        },
        (error) => {
          this.isUploading = false;
          this.toastr.error("Failed to upload thumbnail");
          console.error("Upload error:", error);
        }
      );
  }

  onSave() {
    if (this.selectedThumbnailType === "generated") {
      this.dialogRef.close({
        thumbnailUrl: this.generatedThumbnailUrl,
        thumbnailType: "generated",
      });
    } else {
      if (
        !this.customThumbnailUrl ||
        this.customThumbnailUrl.startsWith("data:")
      ) {
        this.toastr.warning("Please upload a custom thumbnail first");
        return;
      }
      this.dialogRef.close({
        thumbnailUrl: this.customThumbnailUrl,
        thumbnailType: "custom",
      });
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
